(function (window, document, $) {
	$(() => {
		const $select_field = $('.custom-select select');

		if (!$select_field.length) {
			return;
		}

		const minOrder = parseInt($select_field.attr('data-min-order'), 10);

		$select_field.selectize({
			create: true,
			createFilter: function (data) {
				if (parseInt(data, 10) >= minOrder) {
					$('.yco-custom-alert').fadeOut();
				} else {
					$('.yco-custom-alert').fadeIn();
				}
				return parseInt(data, 10) > minOrder;

			},
			render: {
				option_create: function(data, escape) {
					return '<div class="create">' + window.Yco.localization.selectize.Add + ' <br><strong>' + escape(data.input) + '</strong>&hellip;</div>';
				}
			},
		});

	});
})(window, document, jQuery);



// WEBPACK FOOTER //
// ./assets/scripts/selectize.js